import { Component, OnInit } from "@angular/core";
import { roleIdByName } from "src/app/auth/constants/auth.constants";
import { AuthenticationService } from "src/app/auth/services/authentication.service";

interface ICardData {
  title: string;
  body: string;
  showToRoles: roleIdByName[];
}
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
  isLoading = true;
  displayName: string = "";
  protected cardsList: ICardData[] = [
    //Instructor
    {
      title: "Planeación",
      body: "Registro de la planeación anual de eventos de formación y capacitación, con la opción de reasignar planeaciones y sesiones entre jefes de desarrollo e instructores, de acuerdo con el rol seleccionado.",
      showToRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },
    {
      title: "Calendarización",
      body: "Calendarización de sesiones de los eventos programados para su registro automático en GBU.",
      showToRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },
    {
      title: "Mis QR",
      body: "Visualización y descarga de códigos QR o URL, por sesión, para el registro de asistencia de los participantes.",
      showToRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },
    {
      title: "Calendario nacional",
      body: "Visualización y/o descarga de sesiones calendarizadas a nivel nacional.",
      showToRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },

    {
      title: "Asistencia",
      body: "Visualización y descarga de participantes por sesión y registro automático de asistentes en GBU.",
      showToRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },
    {
      title: "DC-3",
      body: "Generación de constancias DC-3 por sesión (se elaboran por organización).",
      showToRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },
    {
      title: "Cumplimiento al plan anual",
      body: "Visualización y descarga del cumplimiento al plan anual (programado vs real).",
      showToRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },

    {
      title: "Sesiones eliminadas",
      body: "Historial de las sesiones eliminadas.",
      showToRoles: [
        roleIdByName.instructor,
        roleIdByName.jefeDesarrollo,
        roleIdByName.oficinasNacionales,
        roleIdByName.liderNacional,
      ],
    },
    //Oficinas Nacionales
    {
      title: "Planeación",
      body: "Visualizar planeaciones de eventos del equipo de Desarrollo e instructores a nivel nacional.",
      showToRoles: [roleIdByName.oficinasNacionales],
    },
    {
      title: "Administración de usuarios",
      body: "Consultar y editar información de roles existentes. Gestionar altas y bajas de usuarios.",
      showToRoles: [roleIdByName.oficinasNacionales],
    },
    {
      title: "Administración de catálogos",
      body: "Los catálogos son las listas desplegables con las que los usuarios ingresan la información. Desde esta sección es posible ver, editar y dar de alta algún registro en ellos.",
      showToRoles: [roleIdByName.oficinasNacionales],
    },
    {
      title: "Administración de eventos",
      body: "Consultar y editar la información de eventos existentes, así como visualizar el detalle de cada uno de ellos.",
      showToRoles: [roleIdByName.oficinasNacionales],
    },
    {
      title: "Configuración",
      body: "Definición de parámetros generales del sistema, permitiendo habilitar la duplicación de la planeación anual y establecer el porcentaje de incremento aplicable en dicho proceso.",
      showToRoles: [roleIdByName.oficinasNacionales],
    },
  ];

  constructor(private authInternalService: AuthenticationService) {}

  ngOnInit(): void {
    this.authInternalService.userObservable.subscribe(u => {
      this.displayName = u ? u.name : "";
      this.isLoading = false;
    });
  }

  showCardItem(cardItem: ICardData) {
    return cardItem.showToRoles.includes(
      this.authInternalService.currentUserValue.fkIdRol
    );
  }
}
